<div class="field-list__container">
  @for (group of groups; track $index) {
    <div class="field-list__group">
      <span class="group__letter">
        {{ group.groupLetter }}
      </span>

      <ul
        class="group__list"
        cdkDropListSortingDisabled
        cdkDropList
      >
        @for (field of group.items; track $index) {
          <li
            class="group__list-item"
            [ngClass]="{'active': field.fieldId === selectedFieldId}"
            [cdkDragData]="field"
            [cdkDragDisabled]="deviceType === 'mobile'"
            [cdkDragStartDelay]="deviceType === 'tablet' ? 300 : 0"
            (cdkDragStarted)="setSelectedField(field)"
            (click)="setSelectedField(field)"
            (keydown)="null"
            cdkDrag
          >
            <span class="item-label">
              <span class="name">
                {{ field.title.name }}
              </span>

              @if (field.title.alternateName) {
                <span class="alternate-name">
                  ({{ field.title.alternateName }})
                </span>
              }
            </span>

            <i class="icon-expand grab-field-icon"></i>

            <div class="drag-preview" *cdkDragPreview>
              <span class="field-title">
                {{ field.title.name}}

                @if (field.title.alternateName) {
                  <span>
                    ({{ field.title.alternateName }})
                  </span>
                }
              </span>
            </div>

            <span class="drag-placeholder" *cdkDragPlaceholder></span>
          </li>
        }
      </ul>
    </div>
  }
</div>
